import { render, staticRenderFns } from "./buy-trial.vue?vue&type=template&id=33ee6c82"
import script from "./buy-trial.vue?vue&type=script&lang=js"
export * from "./buy-trial.vue?vue&type=script&lang=js"
import style0 from "./buy-trial.vue?vue&type=style&index=0&id=33ee6c82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports